import { render, staticRenderFns } from "./Pesca.vue?vue&type=template&id=b068baf6"
import script from "./Pesca.vue?vue&type=script&lang=js"
export * from "./Pesca.vue?vue&type=script&lang=js"
import style0 from "./Pesca.vue?vue&type=style&index=0&id=b068baf6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports